import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";
import { useLocale } from "@/context/LocaleContext";

export const LANGUAGES = ["Dansk", "Engelsk", "Tysk", "Svensk", "Norsk"];

export function LanguageSelect({ value, onChange, disabled, testid = "language-select", className = "" }) {
  const { t } = useLocale();
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Languages className="h-4 w-4 text-muted-foreground shrink-0" />
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger className="w-40" data-testid={testid}>
          <SelectValue placeholder={t("Sprog")}>{t(value)}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          {LANGUAGES.map((l) => (
            <SelectItem key={l} value={l} data-testid={`${testid}-${l}`}>{t(l)}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
